// 查询华歧系数配置
import request from "@/utils/request";

//获取华歧系数
export function getConfig(query) {
  return request({
    url: '/platform/config/getConfig',
    method: 'get',
    params: query
  })
}

// 更新华歧系数
export function saveConfig(data) {
  return request({
    url: '/platform/config/saveConfig',
    method: 'post',
    data: data
  })
}